// Wire enums of the Invoice contract (ABDM-M2-HITYPES build-plan section 5 INV): invoice_type, the
// types allowed per encounter kind (OR-25), Invoice.status, prefill_source.kind. One home so
// components compare against a constant, never an inline string. Same values as the server
// (INV-B1 `INVOICE_TYPES`, INV-B3 `ALLOWED_TYPES`).
//
// Why this is its own module (not hipInvoicesApi.js): component tests mock the API module
// (`jest.mock('.../hipInvoicesApi')`), which would blank these constants out. Pure data, no imports.
// Display names of the types are copy (hipRecordsCopy.js), not data.
import { ENCOUNTER_KIND } from './hipRecordEnums';

// Invoice.type codes of the NRCeS `ndhm-invoice-types` value set.
export const INVOICE_TYPE = Object.freeze({
  CONSULTATION: '00',
  PHARMACY: '01',
  IPD: '02',
  OPD: '03',
  OTHERS: '99',
});

// OR-25: an OPD visit offers Consultation, Pharmacy, OPD, Others; an admission offers Pharmacy, IPD,
// Others. Chip order = array order. CGST/SGST exist on Pharmacy only (OR-22).
export const INVOICE_TYPES_BY_KIND = Object.freeze({
  [ENCOUNTER_KIND.OPD]: Object.freeze([
    INVOICE_TYPE.CONSULTATION, INVOICE_TYPE.PHARMACY, INVOICE_TYPE.OPD, INVOICE_TYPE.OTHERS,
  ]),
  [ENCOUNTER_KIND.IPD]: Object.freeze([
    INVOICE_TYPE.PHARMACY, INVOICE_TYPE.IPD, INVOICE_TYPE.OTHERS,
  ]),
});

// Invoice.status: a DRAFT is editable; LINKED is the frozen snapshot that was sent (409 INVOICE_LOCKED).
export const INVOICE_STATUS = Object.freeze({ DRAFT: 'DRAFT', LINKED: 'LINKED' });

// prefill_source.kind / GET /hip/invoices/prefill `source_kind`: where a draft's lines came from.
// NONE = a blank form (prefill_source.ref is then null); RECEIPT / FINAL_BILL are the two prefill sources.
export const PREFILL_KIND = Object.freeze({ RECEIPT: 'RECEIPT', FINAL_BILL: 'FINAL_BILL', NONE: 'NONE' });
